import * as React from "react"
import { type VTableRowProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import { Td, Tr } from "@digits-shared/DesignSystem/Tables/tableStyles"
import stringHelper from "@digits-shared/helpers/stringHelper"
import { flexRender } from "@tanstack/react-table"

/*
  COMPONENTS
*/
export const VTableRow = React.memo(
  <TData extends object>({
    virtualIndex,
    row,
    cells,
    selected,
    onRowClick,
    rowClassName,
  }: VTableRowProps<TData>) => (
    <Tr
      className={stringHelper.classNames(
        onRowClick && "clickable",
        selected && "selected",
        rowClassName
      )}
      tabIndex={-1}
      onClick={(e) => onRowClick?.(row.original, virtualIndex, e)}
    >
      {cells.map((cell) => (
        <Td key={cell.id} data-column={cell.column.id}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </Td>
      ))}
    </Tr>
  )
) as <TData extends object>(props: VTableRowProps<TData>) => React.ReactElement
